import {inject, Inject, Injectable, Injector, Optional} from '@angular/core';
import {APP_GEOSERVICES_URL} from '../../tokens';

@Injectable({
  providedIn: 'root',
})
export class GeoservicesUrlService {
  private _geoservicesUrl!: string;

  constructor() {
    const geoUrl = inject(APP_GEOSERVICES_URL);
    if (geoUrl) this._geoservicesUrl = geoUrl;
  }

  getGeoservicesBaseUrl() {
    return this._geoservicesUrl;
  }
}
